<style scoped>
span.shop-city {
  max-width: 100%;
}

ul.shop-toggles li a {
  font-weight: initial;
}
</style>
<template lang="pug">
    ul.shop-toggles
      li(v-for='(shop, index) in shops', :title='shop.active ? "Shop accepting orders": "Shop not accepting orders"')
        a
          .row
            .col.s5
              router-link.truncate.shop-city(:to='{name: "shop-details", params: {shopCode: shop.code}}') {{shop.name}}
            .col.s7
              .switch.right
                label
                  | Off
                  input(
                    type='checkbox',
                    :checked='shop.active',
                    @click='toggle(shop)')
                  span.lever
                  | On
</template>
<script>
export default {
  computed: {
    shops () {
      return this.$store.state.profile.shops
    }
  },
  methods: {
    toggle (shop) {
      this.$store
        .dispatch('profile/toggleShopStatus', shop)
        .then(() => {
          this.$snackbar.success('Shop status updated')
        })
        .catch(err => {
          this.$snackbar.error('Could not update shop status: ' + err.message)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/app-shop-toggles.vue